<div class="linked-patients">
  <p class="linked-copy">
    Connect related profiles without merging orders, prescriptions, payments, or notes.
  </p>

  <div class="linked-row" *ngFor="let link of links">
    <mat-icon>{{ kindIcon(link) }}</mat-icon>
    <button mat-button class="linked-name" type="button" (click)="openProfile(link)">
      {{ link.patient?.lastName | uppercase }}, {{ link.patient?.firstName | uppercase }}
    </button>
    <span class="relationship">{{ relationshipLabel(link) | uppercase }}</span>
    <span class="spacer"></span>
    <button mat-button type="button" (click)="edit(link)">EDIT</button>
    <button mat-button type="button" (click)="remove(link)">REMOVE</button>
  </div>
  <p *ngIf="!links.length" class="empty">No linked patients yet.</p>

  <div class="add-row">
    <app-autocomplete-patient
      placeholder="SEARCH EXISTING PATIENT"
      mode="link"
      [excludePatientId]="patient?._id"
      (selectedPatient)="onSelectPatient($event)"
    ></app-autocomplete-patient>
    <mat-form-field>
      <mat-label>RELATIONSHIP</mat-label>
      <mat-select
        [(ngModel)]="relationship"
        [ngModelOptions]="{standalone: true}"
        panelClass="linked-patients-panel"
      >
        <mat-option *ngFor="let option of relationships" [value]="option">{{ option | uppercase }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="relationship === 'Other'">
      <mat-label>DESCRIPTION</mat-label>
      <input matInput [(ngModel)]="otherDescription" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>
    <span class="selected-name" *ngIf="selectedPatient?._id">
      {{ selectedPatient.lastName }}, {{ selectedPatient.firstName }}
    </span>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="busy || !canSave()"
      (click)="addOrUpdate()"
    >
      {{ editingId ? 'UPDATE LINK' : 'ADD LINKED PATIENT' }}
    </button>
  </div>

  <div class="history" *ngIf="history.length">
    <div class="history-title">RELATIONSHIP HISTORY</div>
    <p *ngFor="let event of history">
      {{ event.initials }} — {{ event.date | date:'short' }} — {{ event.item }}
      <span *ngIf="event.notes"> ({{ event.notes }})</span>
    </p>
  </div>
</div>
